import labels from 'src/../config/label.js'

export const mocker = {
  removedFile () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hrmsDropzone/mocker.js